<template>
    <div class="bg-white" style="background-color: white; min-height: 100vh; padding-bottom: 20px;">
        <CContainer>
            <div class="settings-header">
                <br /><br/>
                <!-- Back Button -->
                <CButton class="back-button" @click="$router.go(-1)">
                  ←
                </CButton>

                <!-- Page Title -->
                <h2 class="custom-16px-500 title">Collections</h2>
            </div>

            <CCard class="custom-badge-black">
                <div class="points-container">
                <div class="points-info">
                    <p class="points-title">Your Points</p>
                    <div class="points-value">
                    <img src="@/assets/img/new/coin.png" alt="Coin" class="coin-icon" />
                    <span class="points-text">500 Points</span>
                    </div>
                </div>
                <CButton class="history-button">
                    <CIcon name="cil-history" size="sm" class="mr-2"/>
                    History
                </CButton>
                </div>
            </CCard>
            <div>
                <table class="table table-responsive-sm table-bordered">
                    <thead class="custom-thead">
                        <th>Store Name</th>
                        <th>Target Points</th>
                        <th>Collected Points</th>
                        <th>Reward</th>
                        <th></th>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Coffee ABC</td>
                            <td>100</td>
                            <td>10</td>
                            <td>Free 1 Cup with RM10</td>
                            <td><img src="../assets/img/new/note.png" width="30px" @click="openPopup(item)"/></td>
                        </tr>
                        <tr>
                            <td>Coffee ABC</td>
                            <td>100</td>
                            <td>10</td>
                            <td>Free 1 Cup with RM10</td>
                            <td><img src="../assets/img/new/note.png" width="30px" @click="openPopup(item)"/></td>
                        </tr>
                        <tr>
                            <td>Coffee ABC</td>
                            <td>100</td>
                            <td>10</td>
                            <td>Free 1 Cup with RM10</td>
                            <td><img src="../assets/img/new/note.png" width="30px" @click="openPopup(item)"/></td>
                        </tr>
                        <tr>
                            <td>Coffee ABC</td>
                            <td>100</td>
                            <td>10</td>
                            <td>Free 1 Cup with RM10</td>
                            <td><img src="../assets/img/new/note.png" width="30px" @click="openPopup(item)" /></td>
                        </tr>
                        <tr>
                            <td>Coffee ABC</td>
                            <td>100</td>
                            <td>10</td>
                            <td>Free 1 Cup with RM10</td>
                            <td><img src="../assets/img/new/note.png" width="30px" @click="openPopup(item)" /></td>
                        </tr>
                        <tr>
                            <td>Coffee ABC</td>
                            <td>100</td>
                            <td>10</td>
                            <td>Free 1 Cup with RM10</td>
                            <td><img src="../assets/img/new/note.png" width="30px" @click="openPopup(item)" /></td>
                        </tr>
                     
                    </tbody>
                </table>
                <CButton type="button" class="badge-purple bg-928AFD text-white p-2" block @click="GoToClaim()">Claim Your Rewards</CButton>
                <br /><br />
                //popup collect point
                <div v-if="showPopup" class="popup-overlay" @click.self="closePopup">
                    <div class="popup-content">
                        <h2 class="font-color-171717">How to Collect Coin and Claim Your Reward</h2>
                        <ul class="font-color-171717">
                            <li>Spend <strong>RM100</strong> or more in a single purchase at participating stores to earn <strong>10 points</strong>.</li>
                            <li>At checkout, open the app and scan the barcode provided by the cashier.</li>
                            <li>After a successful scan, 10 points will be added to your account.</li>
                            <li>Keep collecting points until you reach 100 points to claim your reward.</li>
                            <li>Once you have 100 points, go to the Collections section in the app and redeem your voucher.</li>
                        </ul>
                        <p class="cta-text">Start collecting now and get rewarded!</p>
                        <button class="ok-button half-border" @click="closePopup">OK</button>
                    </div>
                </div>
                    </div>
        </CContainer>
    </div>
</template>
<script>
import Mainlayout from "../containers/AllHeader.vue";
import SettingItem from "@/components/SettingItem.vue"; // A reusable setting item component

export default {
  components: {
    SettingItem,
    Mainlayout
  },
  data() {
  return {
    showPopup:false, // Assign imported image to data
    points: 500
  };

},
methods: {
    GoEdit()
    {
      this.$router.push("ProfileUser");
    },
    GoToForgot()
    {
      this.$router.push("ForgotPassword");
    },
    openPopup(item) {
            console.log("Opening popup for", item);
            this.showPopup = true;
        },
        closePopup() {
            this.showPopup = false;
        },
        GoToClaim()
        {
          this.$router.push("ClaimReward");

        }
  }
};
</script>
<style scoped>
.settings-header {
    position: relative; /* Needed for absolute positioning of title */
    display: flex;
    align-items: center;
    justify-content: center; /* Center content */
    padding: 10px 0;
}

.back-button {
    position: absolute;
    left: 10px; /* Adjust spacing from left */
}

.title {
    color: #111927;
    margin: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%); /* Center the title */
}
.cta-text {
    color: #6a5acd;
    font-weight: bold;
    cursor: pointer;
    margin-bottom: 15px;
}

.points-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.points-info {
  display: flex;
  flex-direction: column;
}

.points-title {
  font-size: 14px;
  color: #b3b3b3; /* Lighter text */
  margin-bottom: 5px;
}

.points-value {
  display: flex;
  align-items: center;
}

.coin-icon {
  width: 24px;
  height: 24px;
  margin-right: 6px;
}

.points-text {
  font-size: 18px;
  font-weight: bold;
}

.history-button {
  background: white;
  color: black;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.history-button CIcon {
  margin-right: 5px;
}
</style>